import { render, staticRenderFns } from "./EditReferent.vue?vue&type=template&id=6ea7ec51&"
import script from "./EditReferent.vue?vue&type=script&lang=js&"
export * from "./EditReferent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports